import request from '@/utils/request';
import * as types from '@/api/org/types';
import { reqCatch } from '@/utils/catch';

/** Issue 扩展接口路径使用 /enterprises/{id}/... ，id 取自 enterprise_id 或兼容 group_id */
function enterpriseIssueExtendId(source: { group_id?: string | number; enterprise_id?: string | number }) {
  const id = source?.enterprise_id ?? source?.group_id;
  if (id === undefined || id === null || id === '') {
    return '';
  }
  return String(id);
}

// 是否启用自定义issue类型（组织维度，OrgLayout 等仍走 groups）
export function getIssueSettingActive(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${params.group_id}/issue-extend/issue_extend_open`,
    method: 'get',
    params
  });
}
// 是否启用企业自定义issue类型
export function getIssueSettingActiveE(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/resource/${params.resource_id}/resource_type/ENTERPRISE/setting_type/ENTERPRIS_MODULE`,
    method: 'get'
  });
}
// 是否启用自定义issue类型（组织维度）
export function editIssueSettingActive(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/groups/${data.group_id}/issue-extend/issue_extend_open`,
    method: 'put',
    data
  });
}
// 是否启用企业自定义issue类型-修改
export function editIssueSettingActiveE(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/resource/${params.resource_id}/resource_type/ENTERPRISE/setting_type/ENTERPRIS_MODULE/update`,
    method: 'post',
    data: params.data
  });
}
// 获取issue工作流设置
export function getIssueWorkflowSetting(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/${params.type_id}/followStatusSettings`,
    method: 'get',
    params
  });
}
// 更新issue工作流设置
export function editIssueWorkflowSetting(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/${data.type_id}/followStatusSettings`,
    method: 'put',
    data: data.workflowList
  });
}
// 更新issue状态流转权限设置
export function editAdminForceFlowing(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/${data.type_id}/adminForceFlowing`,
    method: 'put',
    data
  });
}
// 获取issue状态流转权限设置
export function getAdminForceFlowing(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/${params.type_id}/adminForceFlowLimited`,
    method: 'get',
    params
  });
}
// 添加issue类型
export function addIssueType(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/issue_extend_type`,
    method: 'post',
    data
  });
}
// 编辑issue类型
export function editIssueType(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/issue_extend_type/${encodeURIComponent(data.originName)}`,
    method: 'put',
    data
  });
}
// 删除issue类型
export function delIssueType(params: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/issue_extend_type/${encodeURIComponent(params.name)}`,
    method: 'delete',
    params
  });
}
// 添加issue状态
export function addIssueStatus(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/issue_extend_status`,
    method: 'post',
    data
  });
}
// 编辑issue状态
export function editIssueStatus(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/issue_extend_status/${encodeURIComponent(data.originName)}`,
    method: 'put',
    data
  });
}
// 删除issue状态
export function delIssueStatus(params: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/issue_extend_status/${encodeURIComponent(params.name)}`,
    method: 'delete',
    params
  });
}

// 获取issue优先级列表
export function getIssuePriorityList(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/issue_extend_priority_list`,
    method: 'get',
    params
  });
}

// 添加issue优先级
export function addIssuePriority(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/issue_extend_priority`,
    method: 'post',
    data
  });
}
// 编辑issue优先级
export function editIssuePriority(data: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/issue_extend_priority/${encodeURIComponent(data.originName)}`,
    method: 'put',
    data
  });
}
// 删除issue优先级
export function delIssuePriority(params: types.createGroupReqType): Promise<any> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/issue_extend_priority/${encodeURIComponent(params.name)}`,
    method: 'delete',
    params
  });
}

// 获取某个类型定制化的优先级列表
export function getIssueCustomPriority(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/custom/${encodeURIComponent(params.typeName)}/priority`,
    method: 'get'
  });
}
// 编辑某个类型的定制化优先级列表
export function editIssueCustomPriority(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/custom/${encodeURIComponent(data.typeName)}/priority`,
    method: 'put',
    data: data.checkList
  });
}

// 获取issue类型列表
export function getIssueTypeList(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/issue_extend_type_list`,
    method: 'get',
    params
  });
}
// 获取issue状态列表
export function getIssueStatusList(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/issue_extend_status_list`,
    method: 'get',
    params
  });
}
// 获取某个类型定制化的状态列表
export function getIssueCustomStatus(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue-extend/custom/${encodeURIComponent(params.typeName)}`,
    method: 'get',
    params
  });
}
// 编辑某个类型的定制化状态列表 - 弃用
export function editIssueCustomStatus(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/custom/${encodeURIComponent(data.typeName)}`,
    method: 'put',
    data: data.checkList
  });
}

// 编辑某个类型的定制化状态列表 + 最终态
// 弃用 editIssueCustomStatus
export function editIssueCustomStatusWithFinal(data: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(data)}/issue-extend/custom/${encodeURIComponent(data.typeName)}/with-final`,
    method: 'put',
    data: {
      relates: data.checkList,
      final_extend_status_id: data.final_extend_status_id
    }
  });
}

// 获取自定义字段列表
export function getIssueCustomFieldList(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field`,
    method: 'get',
    params
  });
}

// 添加自定义字段
export function addIssueCustomField(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field`,
    method: 'post',
    data: params.data
  });
}
// 编辑自定义字段
export function editIssueCustomField(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/${encodeURIComponent(params.nowName)}`,
    method: 'put',
    data: params.data
  });
}

// 删除自定义字段
export function delIssueCustomField(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/${encodeURIComponent(params.name)}`,
    method: 'delete',
    params
  });
}

// 为自定义字段增加选项值
export function addIssueCustomFieldValue(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/values`,
    method: 'post',
    data: params.data
  });
}

// 修改自定义字段选项值
export function editIssueCustomFieldValue(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/values/${params.value_id}`,
    method: 'put',
    data: params.data
  });
}

// 删除自定义字段选项值
export function delIssueCustomFieldValue(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/values/${params.value_id}`,
    method: 'delete'
  });
}

// 排序自定义字段选项值
export function sortIssueCustomFieldValue(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/values/${params.field_id}/sort`,
    method: 'put',
    data: params.data
  });
}

// 查询自定义字段选项值列表
export function getIssueCustomFieldOptions(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/values/${params.field_id}`,
    method: 'get',
    params
  });
}

// 查询类型下的自定义字段
export function getIssueCustomFieldByType(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/custom/${encodeURIComponent(params.type_name)}`,
    method: 'get',
    params
  });
}

// 为类型新增自定义字段
export function addIssueCustomFieldByType(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/custom/${encodeURIComponent(params.type_name)}`,
    method: 'post',
    data: params.data
  });
}

// 修改类型下的自定义字段
export function editIssueCustomFieldByType(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/custom/${encodeURIComponent(params.type_name)}/${params.field_id}`,
    method: 'put',
    data: params.data
  });
}

// 删除类型下的自定义字段
export function delIssueCustomFieldByType(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/custom/${encodeURIComponent(params.type_name)}/${params.field_id}`,
    method: 'delete',
    params
  });
}

// 排序类型下的自定义字段
export function sortIssueCustomFieldByType(params: types.commonGroupReqType): Promise<types.commonGroupResType> {
  return request({
    url: `/api/v2/enterprises/${enterpriseIssueExtendId(params)}/issue_extend_field/custom/${encodeURIComponent(params.type_name)}/sort`,
    method: 'put',
    data: params.data
  });
}

// ------------------------- 企业详情与更新  start -----------------------------//

/** 企业详情出参 */
export interface EnterpriseDetailRes {
  code?: string;
  name?: string;
  avatar?: string;
  id?: number;
  enterprise_id?: number;
  creator?: string;
  created_at?: string;
  updated_at?: string;
  official_website?: string;
  contact_email?: string;
  introduction?: string;
  contact_address?: string;
}

/** 更新企业信息入参 */
export interface EnterpriseUpdateParams {
  name?: string;
  avatar?: string;
  official_website?: string;
  contact_email?: string;
  introduction?: string;
  contact_address?: string;
}

/**
 * 根据 code 或 id 查询企业详情
 * @param idOrCode 企业 id 或 code
 */
export function getEnterpriseDetail(idOrCode: string | number) {
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/detail/${encodeURIComponent(String(idOrCode))}`,
      method: 'get'
    })
  );
}

/**
 * 更新企业信息
 * @param enterpriseId 企业 id
 * @param data 更新字段
 */
export function updateEnterprise(enterpriseId: number | string, data: EnterpriseUpdateParams) {
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterpriseId}`,
      method: 'put',
      data
    })
  );
}

/** 修改企业命名空间（code） */
export interface EnterpriseUpdateCodeParams {
  code: string;
}

/**
 * 修改企业 code（命名空间）
 * @param idOrCode 企业 id 或当前 code
 * @param data body: { code: 新的命名空间值 }
 */
export function updateEnterpriseCode(idOrCode: string | number, data: EnterpriseUpdateCodeParams) {
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${encodeURIComponent(String(idOrCode))}/code`,
      method: 'put',
      data
    })
  );
}

// ------------------------- 企业WebHook  start -----------------------------//

/**
 * 获取企业WebHook列表
 * @param enterprise_id 企业 id
 * @returns
 */
export function getEnterpriseWebHooks(params: any) {
  const { repoId, ...rest } = params;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${repoId}/hooks`,
      method: 'get',
      params: rest.conf
    })
  );
}

/**
 * 创建企业WebHook
 * @param data
 * @returns
 */
export function createEnterpriseWebHook(data: any) {
  const { enterprise_id, ...rest } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/hooks`,
      method: 'post',
      data: rest
    })
  );
}

/**
 * 编辑企业WebHook
 * @param data
 * @returns
 */
export function editEnterpriseWebHook(data: any) {
  const { enterprise_id, id, ...rest } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/hooks/${id}`,
      method: 'put',
      data: rest
    })
  );
}

/**
 * 获取企业WebHook详情
 * @param data
 * @returns
 */
export function getEnterpriseWebHookDetail(data: { enterprise_id: string; id: string }) {
  const { enterprise_id, id } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/hooks/${id}`,
      method: 'get'
    })
  );
}

/**
 * 删除企业WebHook
 * @param data
 * @returns
 */
export function deleteEnterpriseWebHook(data: { enterprise_id: string; id: string }) {
  const { enterprise_id, id } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/hooks/${id}`,
      method: 'delete'
    })
  );
}

/**
 * 获取企业WebHook请求日志
 * @param data
 * @returns
 */
export function getEnterpriseWebHookLogs(data: {
  enterprise_id: string;
  id: string;
  page?: number;
  per_page?: number;
}) {
  const { enterprise_id, id, ...param } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/hooks/${id}/logs`,
      params: Object.assign({ page: 1, per_page: 10 }, param)
    })
  );
}
/**
 * 获取企业WebHook日志详情
 * @param data
 * @returns
 */
export function getEnterpriseWebHookLogDetail(data: { enterprise_id: string; id: string; logId: string }) {
  const { enterprise_id, id, logId } = data;
  return reqCatch(() =>
    request({
      url: `/api/v2/enterprises/${enterprise_id}/hooks/${id}/logs/${logId}`
    })
  );
}

// ------------------------- 企业WebHook  end -----------------------------//
